import classNames from 'classnames';
import React from 'react';

import css from './IconArtists.module.css';

const IconArtists = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      className={classes}
    >
      <path
        d="M24.3 10.4c0-3-2.4-5.5-5.4-5.5s-5.4 2.4-5.4 5.5c0 3 2.4 5.5 5.4 5.5s5.4-2.5 5.4-5.5zm-5.4 3.5c-1.9 0-3.4-1.6-3.4-3.5s1.5-3.5 3.4-3.5 3.4 1.6 3.4 3.5-1.5 3.5-3.4 3.5zM15.4 21.5c0-2.5-2-4.6-4.6-4.6s-4.6 2-4.6 4.6 2 4.6 4.6 4.6 4.6-2.1 4.6-4.6zm-7.1 0c0-1.4 1.1-2.6 2.6-2.6 1.4 0 2.6 1.1 2.6 2.6 0 1.4-1.1 2.6-2.6 2.6s-2.6-1.2-2.6-2.6zM14.1 28.6c-2.5 0-4.6 2-4.6 4.6s2 4.6 4.6 4.6 4.6-2 4.6-4.6-2.1-4.6-4.6-4.6zm0 7.2c-1.4 0-2.6-1.1-2.6-2.6 0-1.4 1.1-2.6 2.6-2.6 1.4 0 2.6 1.1 2.6 2.6-.1 1.4-1.2 2.6-2.6 2.6z"
        fill="#011602"
      />
      <path
        d="M47.6 1.2c-.7-.9-2-1-2.8-.2-4.6 4.7-10.4 13.4-14 20.8-.3 0-.6-.1-.8-.1-1.5-.5-2.4-1.1-2.9-2-.9-1.7-.1-4.2.8-6.9 1.3-4.2 3-9.4-2.7-11.9C17.7-2.6 8 5.3 4.4 10.2-3.2 20.9-.7 35.8 10 43.5c4.3 3.1 9.3 4.6 14.3 4.6 5.4 0 10.8-1.8 14.9-5.5 2.6-2.3 4.6-5.3 5.7-8.8 1-3.3.9-6-.3-7.9-1.3-2.1-3.7-2.9-5.8-3.3 4-6.4 7.6-14.2 9.1-19.7.2-.7.1-1.2-.3-1.7zM32.2 29.4c-.2 1.2-1 3.3-1.3 4-.3.5-2.6 2.6-5.2 4.9.7-2.3 1.4-5.3 1.3-7.7.2-.5 1.6-2 2.6-2.7l2.6 1.5zm10.7-2.5c.9 1.4.9 3.5.1 6.3-1 3.1-2.7 5.8-5.1 7.9-7.2 6.3-18.5 6.6-26.7.8C1.4 34.8-.9 21.2 6 11.4 9.3 6.8 18.3-.1 24.4 2.6c3.8 1.7 3.1 4.7 1.6 9.5-.9 3-1.9 6-.7 8.5.7 1.4 2 2.4 4 3 .2 0 .3.1.6.1-.4.8-.7 1.5-1 2.3-1.3.7-4 3.2-4 4.6.2 4.2-2.4 10.5-2.4 10.6-.2.4 0 .9.3 1.2.2.1.4.2.6.2.2 0 .5-.1.6-.2 1.8-1.5 7.7-6.7 8.5-7.9.4-.6 1.6-3.7 1.6-5.4 1.1-1.4 2.2-3 3.4-4.7 2.8.3 4.5 1.2 5.4 2.5zm-10 .6L31 26.4c3-7.6 9.6-18 14.9-23.5-2.2 7.3-8 18.2-13 24.6z"
        fill="#011602"
      />
    </svg>
  );
};

export default IconArtists;
